<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T14:45:54+01:00
@Email:  tom@lorinthe.com
@Project: Qrespi
@Last modified by:   tom
@Last modified time: 2019-06-12T17:51:19+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

-->

<template lang="html">

  <c-page
    id="business-solutions"
    :title="$t('solutions.business.title')"
    :jbheader="$t('solutions.business.header')"
    :jblead="$t('solutions.business.lead')"
    :jbimage="assetUrl('img/solutions/b2b.jpg')"
    jbvariant="info">

    <br>
    <h3
      class="text-primary mt-4"
      v-html="$t(`solutions.business.select`)" />

    <div id="business-types-buttons">
      <span v-for="i in 10" :key="i">
        <b-button
          v-if="$te(`solutions.business.type.${i}`, 'en')"
          id="bus-type-select"
          :variant="$COLOR_VARIANTS[i - 1]"
          :pressed="selectedBussType == i"
          size="sm"
          class="circle mt-2 mr-2"
          @click="selectedBussType = i; scrollToUSPs()"
          v-html="$t(`solutions.business.type.${i}.label`)"/>
      </span>
    </div>

    <div v-if="selectedBussType > 0">
      <!-- <hr> -->
      <h3
        class="text-primary mt-4"
        v-html="$t(`solutions.business.type.${selectedBussType}.title`)" />
      <p
        v-if="$te(`solutions.business.type.${selectedBussType}.slot`,'en')"
        class=""
        v-html="$t(`solutions.business.type.${selectedBussType}.slot`)" />

      <b-card-group v-if="selectedBussType > 0" id="USPs" columns>
        <b-card
          v-if="$te(`solutions.business.type.${selectedBussType}._image`,'en')">
          <lzimg
            :src="assetUrl('img/solutions/' + $t(`solutions.business.type.${selectedBussType}._image`))"
            zoom-modal
            style="border: 1px solid #aaa;"
            fluid
            width="600"
            height="450" />
        </b-card>
        <b-card
          v-for="(j, index) in $t(`solutions.business.type.${selectedBussType}._usps`).split(',')"
          :key="j"
          :header="[index+1].toString() + ' ' + $t(`solutions.business.usp.${j}.title`)"
          header-text-variant="white"
          header-bg-variant="info"
          class="mb-2">
          <span v-html="$t(`solutions.business.usp.${j}.slot`)"/>
        </b-card>
      </b-card-group>
    </div>

    <hr>
    <p class="text-secondary" >
      <span v-html="$t(`solutions.business.slot`)"/>
      <b-btn variant="" class="float-right" to="/#contact" v-html="$t('contact.title')"/>
    </p>

  </c-page>
</template>

<script>
export default {
  name: 'BusinessSolutions',
  data: function () {
    return {
      selectedBussType: 0
    }
  },
  methods: {
    scrollToUSPs () {
      this.$scrollTo('#bus-type-select', 400, { x: false, y: true, offset: -120 })
    }
  }
}
</script>

<style lang="scss" scoped >
  #USPs {
    min-height: 500px;
  }
  #business-types-buttons {
    margin: 0 -15px 0 -5px;
    padding: 0;
    .circle {
      border: 4px #999 double !important;
      box-shadow: 3px 2px 12px #333;
      width:110px;
      height:110px;
      border-radius:50%;
      line-height: 1;
      margin: 5px 0;
      font-size: 0.9em;
      &.active {
        border: 4px $primaryWhite double !important;
        width:126px;
        height:126px;
        margin: 0 0 0 -10px !important;
        font-size: 1em;
      }
      &.active + .circle {
      }
    }
  }

</style>
